import React from 'react';
import { FaDesktop, FaShieldAlt, FaUserSecret, FaLock, FaLayerGroup } from 'react-icons/fa';
import { SiGoogle, SiOpenai, SiClaude, SiTelegram, SiWhatsapp, SiDiscord, SiAnydesk, SiTeamviewer } from 'react-icons/si';
import StaticParticles from '../StaticParticles/StaticParticles';
import './Module2Card.css';

const Module2Card = ({ 
  onClick,
  particlesCount = 400,
  particlesOpacity = 0.6,
  particlesSway = 0.5
}) => {
  return (
    <div className="module2-card" onClick={onClick}>
      {/* Canvas частицы */}
      <StaticParticles 
        count={particlesCount}
        color="#FDB241"
        opacity={particlesOpacity}
        sway={particlesSway}
      />
      
      {/* Золотая рамка */}
      <div className="golden-border"></div>
      
      {/* Premium Badge */}
      <div className="premium-badge">
        <span className="premium-icon">⭐</span>
        <span className="premium-text">PREMIUM</span>
      </div>
      
      {/* Основной контент */}
      <div className="card-content">
        
        {/* Верхняя секция: Заголовок слева + VM справа */}
        <div className="top-section">
          
          {/* Левая часть - текст */}
          <div className="text-section">
            <div className="module-label"></div>
            <h2 className="main-title">
              VM-Based <span className="golden-text">Bypass</span>
            </h2>
            <p className="description">
              💻 Virtual Machine • ALL Proctors • Assistant OK
            </p>
          </div>
          
          {/* Правая часть - VM */}
          <div className="vm-section">
            <div className="vm-wrapper">
              {/* Золотые trails */}
              <div className="golden-trail trail-1"></div>
              <div className="golden-trail trail-2"></div>
              <div className="golden-trail trail-3"></div>
              
              <img 
                src={`${process.env.PUBLIC_URL}/images/vm.webp`}
                alt="Virtual Machine" 
                className="vm-img"
              />
            </div>
          </div>
          
        </div>
        
        {/* Карточки фич */}
        <div className="features-row">
          
          <div className="feature-box premium-feature">
            <div className="feature-icon-circle">
              <FaDesktop className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">All Browser Proctors</h4>
              <p className="feature-desc">+ <span className="highlight-text">90% Desktop & Safe Browsers</span></p>
            </div>
          </div>
          
          <div className="feature-box premium-feature">
            <div className="feature-icon-circle">
              <FaShieldAlt className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">Real Hardware</h4>
              <p className="feature-desc"><span className="highlight-text">Modified VM</span> = undetectable</p>
            </div>
          </div>
          
          <div className="feature-box">
            <div className="feature-icon-circle">
              <FaUserSecret className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">Maximum Power</h4>
              <p className="feature-desc">Full system isolation</p>
            </div>
          </div>

          <div className="feature-box">
            <div className="feature-icon-circle">
              <FaLock className="feature-icon-svg" />
            </div>
            <div className="feature-text">
              <h4 className="feature-title">100% Autonomy</h4>
              <p className="feature-desc">No server, fully local</p>
            </div>
          </div>
          
        </div>
        
        {/* Integrated Applications */}
        <div className="apps-section">
          <div className="apps-header">
            <FaLayerGroup className="apps-icon" />
            <span className="apps-label">Full Freedom + Assistant:</span>
          </div>
          <div className="apps-badges">
            <div className="app-badge"><SiGoogle className="badge-icon badge-icon-color" /> Google</div>
            <div className="app-badge"><SiOpenai className="badge-icon badge-icon-color" /> ChatGPT</div>
            <div className="app-badge"><SiClaude className="badge-icon badge-icon-color" /> Claude</div>
            <div className="app-badge"><SiTelegram className="badge-icon badge-icon-color" /> TG</div>
            <div className="app-badge"><SiWhatsapp className="badge-icon badge-icon-color" /> WhatsApp</div>
            <div className="app-badge"><SiDiscord className="badge-icon badge-icon-color" /> Discord</div>
            <div className="app-badge highlight"><FaUserSecret className="badge-icon" /> Assistant can help</div>
          </div>
        </div>

        {/* Remote Control Section */}
        <div className="remote-section">
          <div className="remote-header">
            <FaDesktop className="remote-icon" />
            <span className="remote-label">+ Remote Control Help:</span>
          </div>
          <div className="remote-badges">
            <div className="remote-badge"><SiAnydesk className="badge-icon badge-icon-color" /> AnyDesk</div>
            <div className="remote-badge"><SiTeamviewer className="badge-icon badge-icon-color" /> TeamViewer</div>
          </div>
        </div>
        
        {/* CTA Button */}
        <button className="details-button">
          View Full Technical Details →
        </button>
        
      </div>
      
    </div>
  );
};

export default Module2Card;
